const DealDetailsTab = {
    RECORD: 0,
    FILES: 1,
    CONTACT: 2,
}

export default DealDetailsTab;